import Util from './Util';

export default class Form {
  constructor(args = {}) {
    this.store = args.store;
    this.node = document.querySelector('[data-role="jalan-form"]');
    // inputs
    this.areaInputs = document.querySelectorAll('input[name="lrgCd"]');
    this.catInputs = document.querySelectorAll('input[name="category"]');
    this.commitInputs = document.querySelectorAll('input[name="kdCond"]');
  }

  static noCheckAllInputs(nodes) {
    Array.prototype.slice.call(nodes, 0).forEach((input) => {
      /* eslint-disable no-param-reassign */
      input.checked = false;
       /* eslint-enable no-param-reassign */
    });
  }

  static checkCrInput(nodes, queryKey) {
    const queries = Util.getUrlQueryAsHash();
    Array.prototype.slice.call(nodes, 0).forEach((input) => {
      /* eslint-disable no-param-reassign */
      if (input.value === queries[queryKey]) input.checked = true;
      /* eslint-enable no-param-reassign */
    });
  }

  updateFormView() {
    Form.checkCrInput(this.areaInputs, 'lrgCd');
    Form.checkCrInput(this.catInputs, 'category');
    Form.checkCrInput(this.commitInputs, 'kdCond');
  }

  render() {
    this.updateFormView();
  }
}
